
import WebsiteTranslation from '../translations/WebsiteTranslation';


const allTranslations: Record<string, Record<string, string>> = {
    ...WebsiteTranslation
};

const FindTranslation = (key: string) => {
    if (allTranslations[key]) {
        return allTranslations[key];
    }
    
    console.warn(`Translation not found: ${key}`);
    return WebsiteTranslation.translationNotFound;
}

const TranslationExists = (key: string) => {
    return allTranslations[key] ? true : false;
}


const LanguageHelper = {
    FindTranslation,
    TranslationExists
}


export default LanguageHelper;